"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));
var _reactRouter = require("react-router");
var _omit = _interopRequireDefault(require("lodash/omit"));
var _data = require("../stores/data");
var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));
var _Image = _interopRequireDefault(require("./Image"));
var _uploads = require("../utils/uploads");
var _editor = require("../utils/editor");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function convertLinks(props) {
  var href = props.href,
    children = props.children;
  if (href.startsWith('http')) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExternalLink["default"], {
      href: href,
      children: children
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouter.Link, {
      to: href,
      children: children
    });
  }
}
var Field = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Field() {
    _classCallCheck(this, Field);
    return _callSuper(this, Field, arguments);
  }
  _inherits(Field, _React$Component);
  return _createClass(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        name = _this$props.name,
        type = _this$props.type;
      this.context.setFieldType(name, type);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.context.getFieldValue(this.props.name);
    }
  }, {
    key: "getProps",
    value: function getProps() {
      var props = (0, _omit["default"])(this.props, Object.keys(Field.propTypes));
      return _objectSpread(_objectSpread({}, props), this.getEditProps());
    }
  }, {
    key: "getEditProps",
    value: function getEditProps() {
      if ((0, _editor.canEdit)()) {
        var name = this.props.name;
        return {
          'data-field-name': name
        };
      }
    }
  }, {
    key: "getFallback",
    value: function getFallback() {
      var name = this.props.name;
      var _this$context$parseFi = this.context.parseFieldName(name),
        shortName = _this$context$parseFi.name;
      return "[".concat(shortName, "]");
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.props.type;
      var value = this.getValue();
      if (type.startsWith('image')) {
        return this.renderImage(value);
      } else if (type === 'upload') {
        return this.renderUpload(value);
      } else {
        return this.renderText(value);
      }
    }
  }, {
    key: "renderImage",
    value: function renderImage(set) {
      if (set) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image["default"], _objectSpread({
          set: set
        }, this.getProps()));
      } else {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, this.getProps()), {}, {
          children: this.getFallback()
        }));
      }
    }
  }, {
    key: "renderUpload",
    value: function renderUpload(value) {
      var children = this.props.children;
      if (value) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExternalLink["default"], _objectSpread(_objectSpread({
          href: (0, _uploads.urlForUpload)(value.id)
        }, this.getProps()), {}, {
          children: children
        }));
      } else {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, this.getProps()), {}, {
          children: children
        }));
      }
    }
  }, {
    key: "renderText",
    value: function renderText(value) {
      var type = this.props.type;
      var content = value;
      var Element = type === 'text' ? 'div' : 'span';
      var isMarkdown = type === 'string' || type === 'text';
      if (content && isMarkdown) {
        var options = {
          overrides: {
            a: convertLinks
          }
        };
        if (type === 'text') {
          options.forceBlock = true;
        } else {
          options.forceInline = true;
        }
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_markdownToJsx["default"], _objectSpread(_objectSpread({}, this.getProps()), {}, {
          options: options,
          className: "markdown",
          children: content
        }));
      } else {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Element, _objectSpread(_objectSpread({}, this.getProps()), {}, {
          children: content || this.getFallback()
        }));
      }
    }
  }, {
    key: "renderWithBreaks",
    value: function renderWithBreaks(str) {
      var arr = str.split(' | ');
      return arr.map(function (el, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
          children: [el, i < arr.length - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
        }, i);
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Field, "contextType", _data.DataContext);
Field.propTypes = {
  name: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  type: _propTypes["default"].string,
  fallback: _propTypes["default"].string
};
Field.defaultProps = {
  type: 'string'
};